import { render, staticRenderFns } from "./EducationItem.vue?vue&type=template&id=2ae5bed0&scoped=true&"
import script from "./EducationItem.vue?vue&type=script&lang=js&"
export * from "./EducationItem.vue?vue&type=script&lang=js&"
import style0 from "./EducationItem.vue?vue&type=style&index=0&id=2ae5bed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5bed0",
  null
  
)

component.options.__file = "EducationItem.vue"
export default component.exports